import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-production-viewI';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { KanbanProductionCalendarDialogComponent } from '../kanban-production-calendar-dialog/kanban-production-calendar-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-production-kanban-machine-view-container',
  templateUrl: './production-kanban-machine-view-container.component.html',
  styleUrls: ['./production-kanban-machine-view-container.component.scss']
})
export class ProductionKanbanMachineViewContainerComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public equipments: any[] = [];
  @Output() public onUpdateJob: EventEmitter<any> = new EventEmitter();
  @Input() public defaultImg: string = '';
  @Output() public editCard: EventEmitter<any> = new EventEmitter();
  public colorWarn = 'warn';
  public modeWarn = 'determinate';
  public valueWarn = 65;
  public bufferValueWarn = 85;

  public color = 'success';
  public mode = 'determinate';
  public value = 50;
  public bufferValue = 75;
  @Input() public dateFormatString: string = 'DD/MM/YYYY';
  @Input() public timeFormatString: string = 'hh:mm a';
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  drop(event:any,swimLane:KanbanViewListI) {
    if(swimLane && swimLane.header && swimLane.header.title === 'Unscheduled Jobs') {
      let jobId = "";
        if(event && event.value) {
          jobId =  event.value.id
          
        }
        let data = {
          job: event.value,
          machineId: "",
          scheduleDate: "",
        }
      this.onUpdateJob.emit(data)
    } else {
      let dialogRef = this.dialog.open(KanbanProductionCalendarDialogComponent, {
        width: '500px',
        height: '310px',
        panelClass: 'custom-dialog-container',
        data: {
          equipments: this.equipments,
          machineId: event.value.machineId,
          scheduleDate: event.value.scheduleDate,
        },
      });
  
      dialogRef.afterClosed().subscribe((formValues: any) => {
        
        let jobId = "";
        if(event && event.value) {
          jobId =  event.value.id
          
        }
        if(jobId && formValues.machineId) {
          let data = {
            job: event.value,
            machineId: formValues.machineId,
            scheduleDate: formValues.scheduleDate ?  moment(formValues.scheduleDate, 'YYYY-MM-DD').toDate() : ''
          }
          
          this.onUpdateJob.emit(data)
        }
      });
    }    
  }

  edit(card: any) {
    this.editCard.emit(card);
  }
}
